import { render, staticRenderFns } from "./BoEditLegal.vue?vue&type=template&id=55da57f2&"
import script from "./BoEditLegal.vue?vue&type=script&lang=js&"
export * from "./BoEditLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports